import React, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { protocolsStore } from 'store/mobx/protocols.store';
import TextField from 'ui/TextField';
import Modal from '../../../../ui/Modal';
import useAlert from 'hooks/useAlert';
import FormTextField from 'ui/formItems/FormTextField';

const UpsertGroupModal = ({ setModalOpened }) => {
  const { showAlert } = useAlert();
  const { setOperationMode, selectedGroup, updateSelectedGroup, upsertGroup } = protocolsStore;
  const [group] = useState(selectedGroup());

  const form = useForm({
    defaultValues: {
      name: group?.name ?? '',
    },
  });

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    register,
  } = form;

  const submitClick = async (data) => {
    if (group?.id) {
      groupWillBeChangedAlert(() => performSubmit(data));
    } else {
      await performSubmit(data);
    }
  };

  const cancelClick = () => {
    closeModal();
  };

  const performSubmit = async (data) => {
    updateSelectedGroup({
      id: group?.id,
      ...data,
    });

    const result = await upsertGroup();

    if (!result.success && result.error_code === 2035)
      return showAlert('Группа с таким именем уже существует!', 'error');
    if (!result.success && result.error_code)
      return showAlert(`Код № ${result.error_code}!`, 'error');

    setModalOpened(false);
    successUpsertAlert(closeModal);
  };

  const closeModal = () => {
    updateSelectedGroup(null);
    setOperationMode(null);
    setModalOpened(false);
  };

  const groupWillBeChangedAlert = (callback) =>
    showAlert(`Группа будет изменена!`, 'warning', () => callback());

  const successUpsertAlert = (callback) =>
    showAlert(
      selectedGroup()?.id != null ? `Группа успешно изменена!` : `Группа добавлено успешно!`,
      'success',
      callback,
    );

  return (
    <Modal
      title={`${group?.id ? 'Редактировать' : 'Добавить'} группу протоколов.`}
      onSubmit={handleSubmit(submitClick)}
      onClose={cancelClick}
    >
      <FormProvider {...form}>
        <FormTextField name="name" label={'Наименование'} required />
      </FormProvider>
    </Modal>
  );
};

export default UpsertGroupModal;
